import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  mobile: Yup.string()
    .matches(/^[6-9]\d{9}$/, "Enter Valid Number")
    .required("Mobile number is required"),
});

export const LoginAgencySchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address"
    )
    .required("Mobile number is required"),
  password: Yup.string().required('required'),
});

export const ForgotPasswordAgencySchema = Yup.object().shape({
  email: Yup.string()
    .email("Please enter a valid email address")
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Please enter a valid email address"
    )
    .required("Mobile number is required"),
});

export const resetPasswordAgencySchema = Yup.object().shape({
  password: Yup.string()
    .matches(
      /^(?=.*[!@#$%^&*(),.?":{}|<>])(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
      "Please enter a strong password"
    )
    .required("required"),
});

export const OtpSchema = Yup.object().shape({
    otp: Yup.string()
        .matches(/^\d{5}$/, "OTP must be exactly 5 digits")  // Ensures 5 digits only
        .required("OTP is required")
});